import { useContext } from 'react';
import { StorageContext } from '@/contexts/StorageContext';
import { invariant } from '@/utils/invariant';

export function useDataStore() {
  return invariant(useContext(StorageContext), 'useDataStore must be used inside <StorageProvider>.');
}
